module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "layout-preview-block",
    staticClass: "layout-preview-block"
  }, [_c('div', {
    staticClass: "data-wrapper",
    attrs: {
      "data-specification": _vm.specification,
      "data-category": _vm.category,
      "data-id-area": _vm.idArea,
      "data-id-objekt": _vm.idObject,
      "data-bool-gattungsobjekt": _vm.isGenus
    }
  }, [_c('erco-layout-divider-action-bar', {
    attrs: {
      "prevSiteDataset": false,
      "nextSiteDataset": _vm.datasets[0]
    }
  }), _vm._v(" "), _vm._l((_vm.datasets), function(dataset) {
    return _c('div', {
      key: ("{dataset.lang}" + (dataset.id)),
      staticClass: "item-wrapper",
      attrs: {
        "data-dev-info": ("{ type: 'module', id: '" + (dataset.id) + "', sitenumber: " + (dataset.sitenumber) + ", topicId: '" + (dataset.topicId) + "', templateId: '" + (dataset.templateId) + "', templatePath: '" + (dataset.templatePath) + "' }")
      }
    }, [_c('erco-layout-preview-item', {
      attrs: {
        "dataset": dataset,
        "objecttype": _vm.objecttype,
        "objectname": _vm.objectname
      }
    }), _vm._v(" "), _c('erco-layout-divider-action-bar', {
      attrs: {
        "prevSiteDataset": dataset,
        "nextSiteDataset": _vm.getNextSiteDatasetAfter(dataset)
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4618ad88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoLayout/PreviewBlock.vue
// module id = 619
// module chunks = 0